export const ADMIN_SECRET_PATH = "/admin/admin";
export const ADMIN_ACCESS_KEY = "Tigola1324*";
export const buildAdminUrl = (subpath: string) => {
  const clean = subpath.startsWith("/") ? subpath : `/${subpath}`;
  const key = encodeURIComponent(ADMIN_ACCESS_KEY);
  return `${ADMIN_SECRET_PATH}${clean}?key=${key}`;
};
